export enum FormModalModalConsumableCategoryValues {
  NAME = 'name',
}

export interface FormModalModalConsumableCategoryData {
  [FormModalModalConsumableCategoryValues.NAME]: string;
}
